(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/utils/prolong.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/utils/prolong.js');

'use strict';

async function handleSyndicate(syndicateId) {
  if (!syndicateId) {
    await svs.numbergames.accountSelector.usePlayerAccount();
    return;
  }
  try {
    await svs.numbergames.accountSelector.setActiveAccount(syndicateId);
  } catch (e) {
    svs.utils.paramHandler.remove({
      key: 'pay'
    });
    svs.numbergames.game.utils.dialogs.notActiveMemberProlongDialog();
    svs.numbergames.accountSelector.usePlayerAccount();
    return;
  }
  await svs.numbergames.pay_numbergames.verifyActiveAccount({
    next: () => {},
    cancel: () => {
      svs.numbergames.accountSelector.usePlayerAccount();
    }
  });
}
function getEditWagerFunction(_ref) {
  let playViews = _ref.playViews,
    modelOptions = _ref.modelOptions;
  return async playedWager => {
    Backbone.history.navigate("forlang-mina-spel/".concat(playedWager.get('wagerId')).concat(Backbone.history.location.search), {
      replace: true
    });
    const wager = svs.numbergames.game.utils.editWager.toPayableWager({
      playedWager,
      modelOptions,
      isProlongation: true
    });
    await handleSyndicate(wager.get('syndicateId'));
    if (wager.get('hasJoker') && !wager.get('isSubscription') && !svs.numbergames.game.draw.isJokerOpen) {
      wager.set('jokerPrice', 0);
      svs.numbergames.game.utils.dialogs.showJokerDialog();
    }
    if (wager.get('numRowsExceedMax')) {
      svs.numbergames.game.utils.dialogs.showNumRowsExceedMaxDialog(wager);
    }
    svs.numbergames.game.utils.editWager.renderPlayView({
      model: wager,
      playViews
    });
  };
}
svs.numbergames.game.utils.prolongation = {
  getEditWagerFunction
};

 })(window);